import * as React from 'react';

import { type RowSelectionState } from '@tanstack/react-table';

export function useMultiRowSelection() {
    const [rowSelectionState, setRowSelectionState] = React.useState<RowSelectionState>({});

    const clearRowSelection = React.useCallback(() => {
        setRowSelectionState({});
    }, []);

    const selectedIds = React.useMemo(
        () => Object.keys(rowSelectionState).filter((id) => rowSelectionState[id]),
        [rowSelectionState],
    );

    return { rowSelectionState, setRowSelectionState, selectedIds, clearRowSelection };
}
